var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-panel",
    { staticClass: "complex-filter-panel", attrs: { padding: "false" } },
    [
      _c(
        "div",
        { staticClass: "filters" },
        _vm._l(_vm.filters, function (filter, index) {
          return _c("div", { key: index, staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "dropdown-container" },
              [
                _c("cms-dropdown", {
                  attrs: {
                    options: _vm.keyOptions,
                    placeholder: "Kies filter...",
                    disabled: !!filter.key,
                  },
                  model: {
                    value: filter.key,
                    callback: function ($$v) {
                      _vm.$set(filter, "key", $$v)
                    },
                    expression: "filter.key",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dropdown-container" },
              [
                _c("cms-dropdown", {
                  attrs: {
                    options: _vm.getOperatorOptions(filter.key),
                    placeholder: filter.key ? "Kies conditie..." : "",
                    disabled:
                      !filter.key || _vm.hasOneOperatorOption(filter.key),
                  },
                  on: { input: _vm.updateValue },
                  model: {
                    value: filter.value.operator,
                    callback: function ($$v) {
                      _vm.$set(filter.value, "operator", $$v)
                    },
                    expression: "filter.value.operator",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "dropdown-container" },
              [
                _vm.getFilterType(filter.key) === "string"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: filter.value.value,
                          expression: "filter.value.value",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "input-normal",
                      attrs: { type: "text", placeholder: "Waarde..." },
                      domProps: { value: filter.value.value },
                      on: {
                        blur: [
                          _vm.updateValue,
                          function ($event) {
                            return _vm.$forceUpdate()
                          },
                        ],
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return $event.target.blur()
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            filter.value,
                            "value",
                            $event.target.value.trim()
                          )
                        },
                      },
                    })
                  : _vm.getFilterType(filter.key) === "number"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: filter.value.value,
                          expression: "filter.value.value",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "input-normal",
                      attrs: { type: "number", placeholder: "Waarde..." },
                      domProps: { value: filter.value.value },
                      on: {
                        blur: [
                          _vm.updateValue,
                          function ($event) {
                            return _vm.$forceUpdate()
                          },
                        ],
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return $event.target.blur()
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            filter.value,
                            "value",
                            $event.target.value.trim()
                          )
                        },
                      },
                    })
                  : _vm.getFilterType(filter.key) === "date"
                  ? _c("date-input", {
                      attrs: { placeholder: "Waarde..." },
                      on: { blur: _vm.updateValue },
                      model: {
                        value: filter.value.value,
                        callback: function ($$v) {
                          _vm.$set(
                            filter.value,
                            "value",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "filter.value.value",
                      },
                    })
                  : _c("cms-dropdown", {
                      attrs: {
                        options: _vm.isFilterIncomplete(filter)
                          ? _vm.getAvailableValueOptions(filter.key)
                          : _vm.getValueOptions(filter.key),
                        placeholder: filter.key ? "Kies waarde..." : "",
                        disabled: !filter.key,
                        searchable: "true",
                      },
                      on: { input: _vm.updateValue },
                      model: {
                        value: filter.value.value,
                        callback: function ($$v) {
                          _vm.$set(filter.value, "value", $$v)
                        },
                        expression: "filter.value.value",
                      },
                    }),
              ],
              1
            ),
            _c("div", { staticClass: "row-actions" }, [
              !!filter.key
                ? _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteFilter(filter)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon magicon-minus-circle-filled",
                      }),
                    ]
                  )
                : _vm._e(),
              !_vm.hasIncompleteFilter && index === _vm.filters.length - 1
                ? _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.addFilter.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "icon magicon-plus-circle-filled",
                      }),
                    ]
                  )
                : _vm._e(),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }